import { DateTime } from "luxon";
import { dbService } from "../dbService";
import Alpine from "alpinejs";
import transliterateFromKannada from "./transliteration/transliterateFromKannada";

export const panchangam = {
  // 1. Initial local date (system timezone)
  dateLocal: DateTime.now(),
  minDate: null,
  maxDate: null,
  panchangamData: null,
  transliterate: null,
  async init() {
    await dbService.init();

    // Load initial data for display
    Alpine.effect(async () => {
      let tmp = this.dateLocal;
      let uiLanguage = Alpine.store("userPreferences").uiLanguage;
      let system = Alpine.store("userPreferences").system;
      let name_format = Alpine.store("userPreferences").name_format;
      this.transliterate = new transliterateFromKannada(uiLanguage);
      await this.queryPanchangam();
    });

    const todayStr = this.dateIST.toFormat("yyyy-MM-dd");

    // Responsibility 1: Check if sync is needed
    if (await dbService.needsSync(todayStr)) {
      const year = DateTime.now().year;
      const nextYear = year + 1;
      console.log("Low data detected. Syncing from server...");
      const response = await fetch(
        "/res/panchangam/" + `${year}_${nextYear}.json`,
      ); // Your PHP endpoint
      const data = await response.json();
      await dbService.sync(data);
    }

    // Responsibility 2: Update bounds for the Date Picker
    const bounds = await dbService.getBounds();
    if (bounds.min)
      this.minDate = DateTime.fromISO(bounds.min).set({ hour: 12 });
    if (bounds.max)
      this.maxDate = DateTime.fromISO(bounds.max).set({ hour: 12 });

    if (this.maxDate && this.minDate) {
      if (this.dateLocal > this.maxDate) {
        this.dateLocal = this.maxDate;
      } else if (this.dateLocal < this.minDate) {
        this.dateLocal = this.minDate;
      }
    }

    await this.queryPanchangam();
  },

  // 2. Compute IST based on the local moment
  get dateIST() {
    if (!this.dateLocal) return null;
    return this.dateLocal.setZone("Asia/Kolkata");
  },

  // 3. Getter/Setter for the HTML <input type="date">
  // HTML date inputs strictly require 'yyyy-MM-dd' format
  get date() {
    return this.dateLocal.toFormat("yyyy-MM-dd");
  },

  get dateForWidget() {
    return this.dateLocal.toLocaleString(DateTime.DATE_FULL, {
      locale: Alpine.store("userPreferences").uiLanguage,
    });
  },

  set date(val) {
    if (!val) return;
    // Parse the date and set to 12:00 PM local to avoid
    // timezone offsets pushing the date into yesterday/tomorrow
    this.dateLocal = DateTime.fromISO(val).set({ hour: 12 });
    this.queryPanchangam();
  },

  nextDay() {
    const nextDay = this.dateLocal.plus({ days: 1 });
    if (this.maxDate && nextDay <= this.maxDate) {
      this.dateLocal = nextDay;
    }
  },

  previousDay() {
    const previousDay = this.dateLocal.minus({ days: 1 });
    if (this.minDate && previousDay >= this.minDate) {
      this.dateLocal = previousDay;
    }
  },

  // 4. Method to query your precomputed data
  async queryPanchangam() {
    if (!this.dateIST || !this.dateLocal) return;

    const queryKey = this.dateIST.toFormat("yyyy-MM-dd");
    console.log(`Querying precomputed data for IST date: ${queryKey}`);
    // Fetch from your DB/JSON using queryKey
    let panchangamData = await dbService.getDay(queryKey);

    this.panchangamDataSanskrit =
      this.transliterate.transliterateObject(panchangamData);
    this.panchangamData = this.formatDataNounForms(this.panchangamDataSanskrit);

    console.log(panchangamData);
  },

  formatPanchangamTime(tithiItem) {
    const i18n = Alpine.store("i18n").t; // Your translation data
    if (tithiItem.timestamp === null) {
      if (is_set(tithiItem.dinapurti) && tithiItem.dinapurti === true) {
        return i18n.dinapurti;
      } else {
        return i18n.not_available;
      }
    }
    const lang = Alpine.store("userPreferences").uiLanguage;

    const qualifier = tithiItem.ghati.type;
    console.log("Formatting time for:", tithiItem, qualifier);
    let outputFormat = "yyyy-MM-dd h:mm a";
    const time = DateTime.fromSeconds(tithiItem.timestamp).setZone(
      "Asia/Kolkata",
    );
    if (time.hasSame(this.dateIST, "day")) {
      outputFormat = "h:mm a";
    }

    // return `${i18n[qualifier]} ${time.setLocale("en").toFormat(outputFormat)}`;
    if (lang === "en") {
      return `${i18n[qualifier]} ${time.setLocale("en").toFormat(outputFormat)}`;
    } else {
      return `${time.setLocale("en").toFormat(outputFormat)} ${i18n[qualifier]}`;
    }
  },

  formatPanchangamGhati(tithiItem) {
    const lang = Alpine.store("userPreferences").uiLanguage;
    const i18n = Alpine.store("i18n").t; // Your translation data
    const qualifier = tithiItem.ghati.type;

    if (lang === "en") {
      return `${i18n[qualifier]} ${tithiItem.ghati.value} ${i18n.ghati}`;
    } else {
      return `${tithiItem.ghati.value} ${i18n.ghati} ${i18n[qualifier]}`;
    }
  },

  // This is the single function you call in your HTML
  // formatPanchangamTime(timeValue, indicatorKey) {
  //   const lang = Alpine.store('userPreferences').uiLanguage;
  //   const i18n = Alpine.store('i18n').t; // Your translation data

  //   const indicator = i18n[indicatorKey] || indicatorKey;

  //   if (lang === 'en') {
  //     // English: Upto 7-14
  //     return `${indicator} ${timeValue}`;
  //   } else {
  //     // Kannada/others: 7-14 ವರೆಗೆ
  //     return `${timeValue} ${indicator}`;
  //   }
  // }
  // },

  /**
   * Start dynamic getters for easy access in templates
   */

  get dateSynopsis() {
    if (!this.panchangamData) return "";
    let synopsis = "";
    if (Alpine.store("userPreferences").system === "chandramana") {
      synopsis = `${this.panchangamData["masa"].slice(0, -1)}-${this.panchangamData["paksha"].slice(0, -1)}-${this.panchangamData["tithi"]["tithi"]}`;
    } else {
      synopsis = `${this.panchangamData["saura_masa"].slice(0, -1)}-${Alpine.store("i18n").t.masa} ${this.panchangamData["nakshatra"]["nakshatra"]},  ${this.panchangamData["paksha"].slice(0, -1)}-${this.panchangamData["tithi"]["tithi"]}`;
    }
    return synopsis;
  },

  get vasara() {
    if (Alpine.store("userPreferences").uiLanguage === "sa") {
      return this.dateIST.setLocale("hi").weekdayLong;
    } else {
      return this.dateIST.setLocale(Alpine.store("userPreferences").uiLanguage)
        .weekdayLong;
    }
  },

  get currentDate() {
    if (!this.dateIST) return "";
    return this.dateIST
      .setLocale(Alpine.store("userPreferences").uiLanguage)
      .toLocaleString(DateTime.DATE_FULL);
  },

  get sankalpa() {
    if (!this.panchangamData) return "";

    const regex =
      /[\u0902\u0903\u0C02\u0C03\u0C82\u0C83\u0D02\u0D03\u1E25\u1E43\u003a]$/;

    let sankalpaText = `ಶುಭೇ ದಿನೇ ಶೋಭನೆ ಮೂಹೂರ್ತೇ ಅದ್ಯ ಬ್ರಹ್ಮಣಃ \
      ದ್ವಿತೀಯ-ಪರಾರ್ಧೇ ಶ್ವೇತ-ವರಾಹ-ಕಲ್ಪೇ ವೈವಸ್ವತ-ಮನ್ವನ್ತರೇ \
      ಅಷ್ಟಾವಿಂಶತಿ-ತಮೇ ಕಲಿ-ಯುಗೇ ಪ್ರಥಮ-ಪಾದೇ \
      ಜಂಬೂ-ದ್ವೀಪೇ ಭಾರತ-ವರ್ಷೇ ಭರತ-ಖಂಡೇ \
      ದಂಡಕಾರಣ್ಯೇ ಗೋದಾವರ್ಯಾಃ ದಕ್ಷಿಣೇ ತೀರೇ \
      ಶಾಲಿವಾಹನಶಕೇ ಬೌದ್ಧಾವತಾರೇ ರಾಮಕ್ಷೇತ್ರೇ \
      ಅಸ್ಮಿನ್ ವರ್ತಮಾನೇ ವ್ಯಾವಹಾರಿಕೇ ಪ್ರಭವಾದಿ-ಷಷ್ಟಿ-ಸಂವತ್ಸರಾಣಾಂ ಮಧ್ಯೇ \
      <span class="fw-semibold">${this.panchangamDataSanskrit.samvatsara.slice(0, -1)}</span>-ನಾಮ-ಸಂವತ್ಸರೇ \
      <span class="fw-semibold">${this.panchangamDataSanskrit.ayana.slice(0, -1)}\u0CC7</span>  \
      <span class="fw-semibold">${this.panchangamDataSanskrit.ritu.slice(0, -1)}-ರ್ತೌ</span>
      <span class="fw-semibold">`;

    if (Alpine.store("userPreferences").system === "chandramana") {
      sankalpaText += `${this.panchangamDataSanskrit.masa.slice(0, -1)}`;
    } else {
      sankalpaText += `${this.panchangamDataSanskrit.saura_masa.slice(0, -1)}`;
    }

    sankalpaText += `</span>-ಮಾಸೇ \
    <span class="fw-semibold">${this.panchangamDataSanskrit.paksha.slice(0, -1)}</span>-ಪಕ್ಷೇ `;
  
    const inflected = Alpine.store("i18n").t.inflected_forms;
    console.log(this.panchangamData.tithi.tithi);
    if (this.panchangamData.tithi.tithi.includes(" ")) {
       console.log(
        'Tithi is (with space)',
        inflected[  [this.panchangamDataSanskrit.tithi.tithi]],
        Alpine.store("i18n").t[this.panchangamDataSanskrit.tithi.tithi] 
      )
      let tmp = this.panchangamData.tithi.tithi.split(" ");
      console.log(tmp);

      // Use map to transform only the Tithis, leaving "ಉಪರಿ" (index 1) alone
      let result = tmp.map((word, index) => {
        // Typically indices 0 and 2 are the Tithis in "Tithi1 Upari Tithi2"
        if (index === 0 || index === 2) {
          return inflected[word] || word; // Fallback to original if key missing
        }
        return word; // Returns "ಉಪರಿ" as is
      });
      console.log("Result", result);
      sankalpaText += result.join(" ");
     
    } else {
     console.log(
        'Tithi is',
        this.panchangamDataSanskrit.tithi.tithi,
        inflected[this.panchangamDataSanskrit.tithi.tithi],
        Alpine.store("i18n").t[this.panchangamDataSanskrit.tithi.tithi] 
      )
      sankalpaText +=
        ' <span class="fw-semibold">' +
        inflected[this.panchangamDataSanskrit.tithi.tithi] +
        "</span> ";
    }

    const nakshatraBase =
      this.panchangamDataSanskrit.nakshatra.nakshatra.endsWith("ः")
        ? this.panchangamDataSanskrit.nakshatra.nakshatra.slice(0, -1)
        : this.panchangamDataSanskrit.nakshatra.nakshatra;

    sankalpaText += ` <span class="fw-semibold">${Alpine.store("i18n").t[this.vasara]}</span>-ವಾಸರ-ಯುಕ್ತಾಯಾಂ \
    <span class="fw-semibold">${nakshatraBase}</span>ನಕ್ಷತ್ರ-ಯುಕ್ತಾಯಾಂ \
    <span class="fw-semibold">${this.panchangamDataSanskrit.yoga[0].yoga.replace(regex, "")}</span>-ಯೋಗ-\
    <span class="fw-semibold">${this.panchangamDataSanskrit.karana[0].karana.replace(regex, "")}</span>-ಕರಣ-ಯುಕ್ತಾಯಾಂ  \
    ಏವಂ ಗುಣ-ವಿಶೇಷಣ-ವಿಶಿಷ್ಟಾಯಾಂ ಅಸ್ಯಾಂ ವರ್ತಮಾನಾಯಾಂ ಶುಭತಿಥೌ ...
    `;

    sankalpaText = this.transliterate.transliterate(sankalpaText);

    sankalpaText = sankalpaText.replace(/-/g, "\u00AD");
    sankalpaText = sankalpaText.replace(/fw\u00AD/g, "fw-");

    sankalpaText = sankalpaText.replace(/\u0BAE\u0BCD\u0BC7/g, "\u0BC7");

    return sankalpaText;

    //  ಶ್ರೀಶೃಂಗೇರ್ಯಾಂ";
  },

  formatDataNounForms(object) {
    if (Alpine.store("userPreferences").name_format === "sanskrit") {
      return object;
    }
    console.clear();
    console.log(object);
    return object;
  },

  // getters

  autoSwitchVernacular(string, invertRule = false) {
    const locale = Alpine.store("i18n").t;

    let vernacular =
      Alpine.store("userPreferences").name_format === "vernacular";
    if (invertRule) {
      vernacular = !vernacular;
    }

    console.log(
      string + " ; vernacular " + vernacular + " ; rule inverted " + invertRule,
    );

    if (vernacular) {
      return locale[string] ?? string;
    } else {
      return string;
    }
  },
};
